module.exports = __webpack_public_path__ + "img/icon-user.18fa09e5.svg";